import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/contact.css";

const Contact = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "contact");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Contact | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="contact" />
				<div className="content-wrapper">
					<div className="contact-logo-container">
						<div className="contact-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="contact-container">
						<div className="title contact-title">
							Let's Get in Touch: Ways to Connect with Me
						</div>

						{/* <div className="subtitle contact-subtitle">
							Thank you for your interest in getting in touch with
							me. I welcome your questions, feedback, and
							suggestions. If you have a specific question or
							comment, please feel free to email me directly at
							&nbsp;{" "}
							<a href={`mailto:${INFO.main.email}`}>
								{INFO.main.email}
							</a>
							. I make an effort to respond to all messages as soon as possible, although it may take me longer sometimes due to work commitments.
							Alternatively, you can connect with me on professional networking sites, Don't hesitate to reach out.
							Thanks again for your interest, and I look forward to hearing from you!
						</div> */}

						<div className="subtitle contact-subtitle">
							Thank you for your interest in getting in touch with
							me. I value your questions, feedback, and suggestions.
							For specific inquiries or comments, you can email me at 
							&nbsp;{" "}
							<a href={`mailto:${INFO.main.email}`}>
								{INFO.main.email}
							</a>
							. I make it a priority to respond promptly, though at times it may take a little longer due to work commitments.
							I welcome you to connect with me on professional networking platforms and reach out anytime.
							<br></br><b>For urgent and quick queries, just click the WhatsApp icon at the bottom-right to reach me instantly.</b>
							<br></br> <br></br>
							I appreciate your interest and look forward to connecting with you.
						</div>

					</div>

					<div className="socials-container">
						<div className="contact-socials">
							<Socials />
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Contact;
